import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import { blue } from "@mui/material/colors";
import { Params } from "../../../interfaces/interfaces";

type Props = {
  params: Params;
  handleChange: <P extends keyof Params>(prop: P, value: Params[P]) => void;
};

export function ServiceNameTextField({ params, handleChange }: Props) {
  return (
    <>
      <FormLabel>ServiceName</FormLabel>
      <TextField
        type="text"
        name="serviceName"
        value={params.serviceName}
        onChange={(e) => {
          handleChange("serviceName", e.target.value);
        }}
        spellCheck="false"
        sx={{
          "& fieldset": {
            borderColor: blue[800],
          },
          "&:hover": {
            "&& fieldset": {
              border: "1px solid white",
            },
          },
        }}
      />
    </>
  );
}
